import {toggleAttribute} from '../../js/utils/helpers';

export default class Accordion {

  constructor($el) {
    this.accordionHead = $el;
    this.accordionToggle = $el.find('.js-accordion_toggle').eq(0);
    this.accordionPanel = $el.next();

    this.handleEvents();
  }

  handleEvents() {
    this.accordionToggle.click(e => this.toggleAccordion(e));
  }

  toggleAccordion() {
    this.accordionPanel.slideToggle('fast');

    toggleAttribute(
      this.accordionToggle,
      'aria-expanded'
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/accordion/accordion.js